<template>
  <div style="background:#fff; padding:20px;">
    <div v-if="!embedded" style="margin-bottom:20px;">
      <a-select v-model="selectedEventId" allow-clear placeholder="选择赛事" style="width:280px; margin-right:10px;" @change="handleEventChange">
        <a-select-option v-for="item in eventOptions" :key="item.id" :value="item.id">{{ item.title }}</a-select-option>
      </a-select>
      <a-button type="primary" @click="loadRule">加载规则</a-button>
    </div>

    <template v-if="activeEventId">
      <a-card title="积分规则" size="small" style="margin-bottom:20px;">
        <a-form-model :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
          <a-form-model-item label="计分模式">
            <a-radio-group v-model="rule.scoringType">
              <a-radio value="qualify_rounds">排位赛汇总（各轮次名次给分，队伍跨轮汇总）</a-radio>
              <a-radio value="points_by_distance">积分赛按项目（10米/200米等各项目名次给分，相加）</a-radio>
              <a-radio value="two_rounds_sum">两轮成绩相加（总用时少者胜）</a-radio>
            </a-radio-group>
          </a-form-model-item>

          <template v-if="rule.scoringType === 'qualify_rounds' || rule.scoringType === 'points_by_distance'">
            <a-form-model-item label="名次分值">
              <div v-for="i in 8" :key="i" style="display:inline-block; margin-right:16px;">
                <span style="margin-right:6px;">第{{ i }}名</span>
                <a-input-number v-model="rankPoints[i]" :min="0" style="width:80px;" />
              </div>
            </a-form-model-item>
            <a-form-model-item v-if="rule.scoringType === 'qualify_rounds'" label="参与轮次">
              <a-select v-model="roundIds" mode="multiple" allow-clear placeholder="不选=全部已发布轮次" style="width:100%;">
                <a-select-option v-for="item in roundOptions" :key="item.id" :value="item.id">{{ item.roundName }}{{ item.distance ? '（' + item.distance + '米）' : '' }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item v-else label="参与项目">
              <a-select v-model="distances" mode="multiple" allow-clear placeholder="不选=全部项目" style="width:100%;">
                <a-select-option v-for="item in distanceOptions" :key="item.id" :value="item.distance">{{ item.distance }}米</a-select-option>
              </a-select>
            </a-form-model-item>
          </template>

          <a-form-model-item v-else label="相加轮次">
            <a-select v-model="roundIds" mode="multiple" allow-clear placeholder="选择两个轮次，成绩相加按用时排名" style="width:100%;">
              <a-select-option v-for="item in roundOptions" :key="item.id" :value="item.id">{{ item.roundName }}{{ item.distance ? '（' + item.distance + '米）' : '' }}</a-select-option>
            </a-select>
            <div style="color:#999; font-size:12px;">选中的队伍成绩将换算为秒相加，总用时少者排名靠前</div>
          </a-form-model-item>

          <a-form-model-item :wrapper-col="{ offset: 4 }">
            <a-button type="primary" :loading="saving" @click="saveRule">保存并计算积分</a-button>
            <a-button style="margin-left:12px;" @click="recalc">重新计算</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-card>

      <a-card title="积分榜" size="small">
        <a-select v-model="categoryId" allow-clear placeholder="全部组别" style="width:200px; margin-bottom:12px;" @change="loadRanking">
          <a-select-option v-for="item in categoryOptions" :key="item.id" :value="item.id">{{ item.categoryName }}</a-select-option>
        </a-select>
        <a-table :columns="columns" :data-source="rankings" rowKey="id" size="small" :pagination="false">
          <span slot="rankNo" slot-scope="text">
            <a-tag :color="rankColor(text)">{{ text }}</a-tag>
          </span>
          <span slot="totalPoints" slot-scope="text">
            <strong>{{ text }}</strong>
          </span>
          <span slot="totalSeconds" slot-scope="text, record">
            {{ record.scoringType === 'two_rounds_sum' ? formatSeconds(text) : '—' }}
          </span>
        </a-table>
        <div v-if="!rankings.length" style="text-align:center; color:#999; padding:30px 0;">暂无积分数据，请先配置规则并发布成绩</div>
      </a-card>
    </template>
  </div>
</template>

<script>
import { getDragonCategoryList, getDragonDistanceConfigList, getDragonEventList, getDragonRanking, getDragonRoundOptions, getDragonScoringRule, recalcDragonScoring, saveDragonScoringRule } from '@/api'

export default {
  name: 'DragonScoring',
  props: {
    eventId: {
      type: Number,
      default: undefined
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedEventId: undefined,
      categoryId: undefined,
      eventOptions: [],
      categoryOptions: [],
      roundOptions: [],
      distanceOptions: [],
      rankPoints: {},
      roundIds: [],
      distances: [],
      rule: { scoringType: 'qualify_rounds', exists: false },
      rankings: [],
      saving: false,
      columns: [
        { title: '排名', dataIndex: 'rankNo', width: 70, scopedSlots: { customRender: 'rankNo' } },
        { title: '队伍', dataIndex: 'teamName' },
        { title: '总积分', dataIndex: 'totalPoints', width: 100, scopedSlots: { customRender: 'totalPoints' } },
        { title: '总用时', dataIndex: 'totalSeconds', width: 100, scopedSlots: { customRender: 'totalSeconds' } },
        { title: '明细', dataIndex: 'detail', customRender: text => formatDetail(text) }
      ]
    }
  },
  created() {
    getDragonEventList({ page: 1, pageSize: 200 }).then(res => {
      this.eventOptions = res.data.list || []
      if (this.eventId) {
        this.handleEventChange()
      }
    })
  },
  watch: {
    eventId(val) {
      if (val) {
        this.handleEventChange()
      }
    }
  },
  computed: {
    activeEventId() {
      return this.eventId || this.selectedEventId
    }
  },
  methods: {
    handleEventChange() {
      this.categoryId = undefined
      this.categoryOptions = []
      this.roundOptions = []
      this.distanceOptions = []
      this.rankings = []
      this.rule = { scoringType: 'qualify_rounds', exists: false }
      this.roundIds = []
      this.distances = []
      this.rankPoints = {}
      if (!this.activeEventId) return
      getDragonCategoryList({ eventId: this.activeEventId }).then(res => {
        this.categoryOptions = res.data.list || []
      })
      getDragonRoundOptions({ eventId: this.activeEventId }).then(res => {
        this.roundOptions = res.data || []
      })
      this.loadDistances()
      this.loadRule()
      this.loadRanking()
    },
    loadDistances() {
      getDragonDistanceConfigList({ eventId: this.activeEventId, pageSize: 100 }).then(res => {
        const list = res.data.list || []
        const distances = []
        list.forEach(d => {
          if (!distances.find(x => x.distance === d.distance)) {
            distances.push({ distance: d.distance })
          }
        })
        this.distanceOptions = distances
      }).catch(() => {})
    },
    loadRule() {
      getDragonScoringRule({ eventId: this.activeEventId }).then(res => {
        this.rule = { scoringType: 'qualify_rounds', exists: false, ...res.data }
        if (res.data.ruleConfig) {
          const config = res.data.ruleConfig
          this.rankPoints = config.rankPoints || {}
          this.roundIds = config.roundIds || []
          this.distances = config.distances || []
        }
      })
    },
    saveRule() {
      const config = {}
      if (this.rule.scoringType === 'two_rounds_sum') {
        if (!this.roundIds || this.roundIds.length < 2) {
          this.$message.warning('请至少选择两个轮次')
          return
        }
        config.roundIds = this.roundIds
      } else if (this.rule.scoringType === 'qualify_rounds') {
        if (this.roundIds && this.roundIds.length) config.roundIds = this.roundIds
        config.rankPoints = this.rankPoints
      } else {
        if (this.distances && this.distances.length) config.distances = this.distances
        config.rankPoints = this.rankPoints
      }
      this.saving = true
      saveDragonScoringRule({
        eventId: this.activeEventId,
        scoringType: this.rule.scoringType,
        ruleConfig: config
      }).then(() => {
        this.$message.success('规则已保存并计算积分')
        this.loadRanking()
      }).finally(() => {
        this.saving = false
      })
    },
    recalc() {
      recalcDragonScoring({ eventId: this.activeEventId }).then(() => {
        this.$message.success('积分已重新计算')
        this.loadRanking()
      })
    },
    loadRanking() {
      if (!this.activeEventId) return
      getDragonRanking({ eventId: this.activeEventId, categoryId: this.categoryId }).then(res => {
        this.rankings = (res.data.list || []).map(item => ({ ...item, scoringType: this.rule.scoringType }))
      })
    },
    rankColor(rank) {
      if (rank === 1) return 'gold'
      if (rank === 2) return 'silver'
      if (rank === 3) return 'bronze'
      return 'default'
    },
    formatSeconds(seconds) {
      if (seconds === null || seconds === undefined) return '—'
      const m = Math.floor(seconds / 60)
      const s = (seconds % 60).toFixed(0).padStart(2, '0')
      return `${m}:${s}`
    }
  }
}

function formatDetail(text) {
  if (!text) return '—'
  try {
    const obj = JSON.parse(text)
    return Object.entries(obj).map(([k, v]) => `${k}: ${v}`).join('；')
  } catch (e) {
    return text
  }
}
</script>
